export default __webpack_public_path__ + "static/media/bg.893472ba.png";